<template>
  <div class="top">
    <div>
      <router-link :to="{path: '/'}">
        <img src="@/assets/img/log.png" alt>
      </router-link>
      <p>万知.com</p>
    </div>
    <div>
      <input v-model="keyword" id="bdcsMain" type="text" placeholder="请输入搜索内容">
      <div class="search_btn" @click="searchInfoFn(keyword)">搜索</div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  data () {
    return {
      keyword: ''
    }
  },
  mounted () {
    if (this.$route.path === '/search' && this.$route.query.keyword) {
      this.keyword = this.$route.query.keyword || ''
    }
  },
  methods: {
    searchInfoFn (keyword) {
      if (keyword) {
        this.$router.push({name: 'Search', query: { keyword }})
      } else {
        this.$message.error('请先输入搜索内容！')
      }
    }
  }
}
// (function () {
//   document.write(unescape('%3Cdiv id="bdcs"%3E%3C/div%3E'))
//   var bdcs = document.createElement('script')
//   bdcs.type = 'text/javascript'
//   bdcs.async = true
//   bdcs.src = 'http://znsv.baidu.com/customer_search/api/js?sid=2146553622533554646' + '&plate_url=' + encodeURIComponent(window.location.href) + '&t=' + Math.ceil(new Date() / 3600000)
//   var s = document.getElementsByTagName('script')[0]
//   s.parentNode.insertBefore(bdcs, s)
// })()
</script>

<style scoped>
.top {
  width: 1200px;
  margin: 0 auto;
  padding: 10px 0;
  overflow: hidden;
}
.top > div:first-child {
  float: left;
}
.top > div:first-child a {
  height: 65px;
  float: left;
}
.top > div:first-child p{
  float: left;
  margin-left: 5px;
  margin-top: 33px;
  font-size: 18px;
  color: #888;
}
.top > div:last-child {
  float: right;
  height: 72px;
  position: relative;
  padding-top: 16px;
  box-sizing: border-box;
}
.top > div:last-child input {
  width: 450px;
  height: 18px;
  padding: 10px 10px 8px 12px;
  border: 2px solid #ff971b;
  line-height: 18px;
  border-radius: 3px 0 0 3px;
  float: left;
}
.search_btn {
  display: inline-block;
  width: 100px;
  height: 40px;
  color: #fff;
  overflow: hidden;
  cursor: pointer;
  font-size: 20px;
  letter-spacing: 1px;
  text-align: center;
  background-color: #ff971b;
  border-radius: 0 3px 3px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/index/Top.vue